/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Line_MeetingInputs */



/**
* | output |
* | --- |
* | "Talk this conversation through" |
*
* @param {Chat_Line_MeetingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_line_meeting = /** @type {((inputs?: Chat_Line_MeetingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Line_MeetingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Spar over dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échange à propos de cette conversation")
	return /** @type {LocalizedString} */ ("Talk this conversation through")
});